
















































































import { Inject, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
// import UpdateUserDialog from '@/custom/page/useradmin/user/UpdateUserDialog.vue';
// import CreateUserDialog from '@/custom/page/useradmin/user/CreateUserDialog.vue';
import UserManagementService from "@/admin/user-management/user-management.service";
import { CREATE_MAP, viewPageToQueryPage } from "@/constants";
import ConfirmDialog from "@/custom/page/common/ConfirmDialog.vue";
import SetPasswordUserDialog from "@/custom/page/useradmin/user/SetPasswordUserDialog.vue";
import UserPrivilegeService from "@/entities/user-privilege/user-privilege.service";

@Component({ components: { ConfirmDialog, SetPasswordUserDialog } })
export default class UserListPage extends Vue {
  @Inject() userAdminDataFn;

  headers = [
    { text: 'ID', value: 'id' },
    { text: 'Họ tên', value: 'fullname' },
    { text: 'Mail', value: 'mail' },
    { text: 'UserName', value: 'login' },
    // { text: 'Vai trò', value: 'roles', sortable: false },
    { text: 'Mobile', value: 'mobileLogin' },
    { text: '', value: 'actions' },
  ];

  users = [];

  userPage = {
    page: 1,
    size: 20,
    total: 20,
  };
  loading = false;
  userMobileAccesses = {};

  mounted() {
    this.fetchUsers();
  }

  @Watch('userPage.page')
  @Watch('userPage.size')
  async fetchUsers() {
    this.loading = true;
    let userManagementService = new UserManagementService();
    let userRs = await userManagementService.retrieve(viewPageToQueryPage(this.userPage));
    this.users = userRs.data;
    this.userPage.total = Number(userRs.headers['x-total-count']);
    this.users.map(user => {
      this.userMobileAccesses[user.id] = user.userPrivilege.mobileAccessEnabled;
    });

    this.loading = false;
  }

  get userMap() {
    return CREATE_MAP(this.users);
  }

  get items() {
    // console.log(users);
    return this.users.filter(user => {
      return (user.firstName + ' ' + user.lastName).toLowerCase().includes(this.searchByNameValue.toLowerCase());
    });
  }

  updateUserDialog = {
    open: false,
    userPrivilege: {},
  };

  createUserDialog = {
    open: false,
  };

  editItem(item) {
    this.updateUserDialog = {
      open: true,
      userPrivilege: Object.assign({}, item),
    };
  }

  openCreateUserDialog() {
    this.createUserDialog = {
      open: true,
    };
  }

  deleteUserDialog = {
    open: false,
    title: '',
    text: '',
    onOk: () => undefined,
  };

  deleteItem(item) {
    // this.deleteUserDialog = {
    //   open: true,
    //   title: 'Xác nhận',
    //   text: `Bạn có chắc chắn muốn xóa user ${item.firstName} ${item.lastName} (id=${item.id})?`,
    //   onOk: async () => {
    //     let userManagementService = new UserManagementService();
    //     try {
    //       let rs = await userManagementService.remove(item.login);
    //       (this.$root as any).$bvToast.toast(`Xóa thành công user: ${item.id}`, {
    //         toaster: 'b-toaster-top-center',
    //         title: 'Success',
    //         variant: 'success',
    //         solid: true,
    //         autoHideDelay: 5000,
    //       });
    //       await this.fetchUsers();
    //     } catch (e) {
    //       (this.$root as any).$bvToast.toast('Đã có lỗi xảy ra: ' + e, {
    //         toaster: 'b-toaster-top-center',
    //         title: 'Thất bại',
    //         variant: 'danger',
    //         solid: true,
    //         autoHideDelay: 5000,
    //       });
    //     }
    //   },
    // };
  }

  searchByNameValue = '';

  resetPasswordDialog = { open: false, user: {} };

  resetPassword(item) {
    this.resetPasswordDialog = {
      open: true,
      user: item,
    };
  }

  changeMobileAccess(item, value) {
    new UserPrivilegeService().partialUpdate({ id: item.userPrivilege.id, mobileAccessEnabled: value });
  }
}
